import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import FiltersTab from "./FiltersTab";

function Filters () {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <FiltersTab />
      <Footer />
    </DashboardLayout>
  );
}

export default Filters;
